'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'srcCategory', 'srcCategories', 'SrcCategoryService', 'StatusService',
    function ($scope, $modalInstance, srcCategory, srcCategories, SrcCategoryService, StatusService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.uniqueName = true;
            $scope.srcCategory = angular.copy(srcCategory);

            if (angular.equals(srcCategory, {}) || $scope.srcCategory.parent == null) {
                $scope.srcCategory.parent = {id: null};
            }

            $scope.srcCategories = angular.copy(srcCategories);
            $scope.srcCategories.splice($scope.srcCategories.indexOf($scope.srcCategories.find(cat => cat.id === srcCategory.id)), 1);
            $scope.srcCategories.unshift({id: null, name: 'Нет'});

            if (srcCategory == null || angular.equals({}, srcCategory) || srcCategory.id == null) {
                $scope.title = "Создание новой категории источников софинансирования";
            } else {
                $scope.title = "Редактирование категории источников софинансирования \"" + $scope.srcCategory.name + "\"";
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.srcCategory.status) {
                    $scope.srcCategory.status = data._embedded;
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.srcCategory);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                SrcCategoryService.api.isUniqueName({name: name}, {id: $scope.srcCategory.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        // endregion

    }];